export const DictionaryClientDataRequestType = {
  Address: 'CLNT_REQ_ADDR',
  ContactInformation: 'CLNT_REQ_CONTACT',
  BeneficialOwner: 'CLNT_REQ_OWNER',
  Associates: 'CLNT_REQ_ASSOC',
  CompanyInformation: 'CLNT_REQ_INFO',
  LegalRepresentative: 'CLNT_REQ_LEGAL',
  PersonalInformation: 'CLNT_REQ_PERS_INFO',
  Other: 'CLNT_REQ_OTHER',
  BankAccount: 'CLNT_REQ_BANK_ACC',
};

export const DictionaryClientDataRequestAddressType = {
  Office: 'OFFICE_ADDRESS',
  Home: 'HOME_ADDRESS',
  Mailing: 'MAILING_ADDRESS',
};

export const DictionaryContractType = {
  OPERATIONAL_LEASING: 'OL',
  FINANCIAL_LEASING: 'FL',
  CREDIT: 'CR',
};

export const DictionaryRequestType = {
  RQST_CLIENT_DATA: 'RQST_CLIENT_DATA',
  RQST_ASSET_DOCUMENT: 'RQST_ASSET_DOCUMENT',
};

export const DictionaryCommentType = {
  TEXT: 'TEXT_MESSAGE',
  DOCUMENT: 'DOCUMENT_UPLOAD',
};

export const DictionaryRequestStatus = {
  POSTED: 'POSTED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
};

export const DictionaryAssetDocumentRequestTypes = {
  DRIVING_ABROAD: 'RQST_DRIVING_ABROAD',
  DAMAGE_DELEGACY: 'RQST_DAMAGE_DELEGACY',
  OTHER: 'RQST_OTHER',
  VIGNETTE: 'RQST_VIGNETTE',
};

export const DictionaryContractModificationReason = {
  OTHER: 'OTHER',
};

export const DictionaryAssetDocumentRequestTypeParameter = {
  MAX_MONTHS_TRANSIT_END_RQST_DAMAGE_DELEGACY: 'MAX_MONTHS_TRANSIT_END_RQST_DAMAGE_DELEGACY',
  MIN_DAYS_TRANSIT_START_RQST_DAMAGE_DELEGACY: 'MIN_DAYS_TRANSIT_START_RQST_DAMAGE_DELEGACY',
  MAX_PAST_YEARS_RQST_DAMAGE_DELEGACY: 'MAX_PAST_YEARS_RQST_DAMAGE_DELEGACY',
  HAS_GREEN_CARD_STEP_RQST_DRIVING_ABROAD: 'HAS_GREEN_CARD_STEP_RQST_DRIVING_ABROAD',
};

export const DictionaryInsuranceTypePortalCode = {
  CASCO: 'CASCO',
  RCA: 'RCA',
  RTI: 'RTI',
};

export const DictionaryAssetDeliveryStatus = {
  ESTIMATED: 'ESTIMATED',
  DELIVERED: 'COMPLETED',
};

export const DictionaryContractItemServices = {
  MAINTENANCE: 'ASSISTANT_MON_A',
  TOP: 'SERVICE_EXC_OT_A',
  TIRE_MANAGEMENT: 'TYRES_SUMMER_OT_A',
  FUEL_MANAGEMENT: 'SERVICE_PLUS_OT_A',
};
